import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";

import { handleError } from "../../app-messages";

export const reviewCandidate = ({ candidateId, status, reviewNote }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.patch(`/candidates/${candidateId}`, {
        status,
        reviewNote,
      });

      const { data } = handleAxiosResponse(response);

      return { status: data.status, reviews: data.reviews };
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
